var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgWhite",attrs:{"id":"app"}},[_c('div',{staticClass:"hero-head"}),_c('router-view'),_c('Navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }